import { useSync } from '../contexts/SyncContext';

function formatRelative(date) {
  if (!date) return null;
  const diffMs = Date.now() - date.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'gerade eben';
  if (mins < 60) return `vor ${mins} Min.`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `vor ${hours} Std.`;
  const days = Math.floor(hours / 24);
  return `vor ${days} Tag${days > 1 ? 'en' : ''}`;
}

export default function SyncFooterButton() {
  const { online, lastSync, syncing, progress, triggerSync } = useSync();

  const rel = formatRelative(lastSync);
  const title = syncing
    ? (progress.message || 'Synchronisation läuft …')
    : !online
      ? 'Synchronisation nur online möglich'
      : rel
        ? `Zuletzt synchronisiert ${rel}. Klicken zum Aktualisieren.`
        : 'Daten für Offline-Nutzung synchronisieren';

  const handleClick = async () => {
    const result = await triggerSync({ manual: true });
    if (result?.reason === 'offline') {
      // silent – button is disabled anyway
    } else if (!result?.success && result?.error) {
      console.warn('[Sync]', result.error);
    }
  };

  return (
    <button
      type="button"
      className="footer-sync-btn"
      onClick={handleClick}
      disabled={syncing || !online}
      title={title}
      aria-label={syncing ? 'Synchronisation läuft' : 'Daten synchronisieren'}
    >
      <span className={`footer-sync-btn__icon${syncing ? ' is-spinning' : ''}`} aria-hidden="true">🔄</span>
      {syncing ? 'Synchronisiert …' : 'Daten synchronisieren'}
      {!syncing && rel && <span className="footer-sync-btn__meta"> · {rel}</span>}
    </button>
  );
}
